import { memo } from "react";
import CartItemSmall from "./CartItemSmall";
import { Product } from "@/types/product";

type ProductListProps = {
  productList: Product[];
  setProductDescription: (product: Product) => void;
};

export const ProductList = memo(function ProductList({
  productList,
  setProductDescription,
}: ProductListProps) {
  return (
    <div className="widget-displaying-results w-[100%]">
      <div className="nut-grid !grid-cols-2 gap-[16px] mt-[16px]">
        {productList.slice(0, 2).map((product) => (
          <CartItemSmall
            key={product.id}
            image={product?.images[0].src}
            imageAlt="cart image 1"
            title={product.title}
            currentPrice={product?.variants?.[0]?.price}
            onClick={() => setProductDescription(product)}
          />
        ))}
      </div>
    </div>
  );
});
